import {SmallCloseIcon} from '@chakra-ui/icons';
import {Box, Flex, StackDivider, Text} from '@chakra-ui/react';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ButtonMinor from '../../components/ButtonMinor';
import {pinsSearchIdsSet} from '../../reducers/pinsReducer';
import {textInputPlaceholderSet} from '../../reducers/uiReducer';
import Filters from './Filters';
import InputBar from './InputBar';
import PanoClusterIcon from './Minimap/PanoClusterIcon';

const PinsListFilters = ({
  children,
  contentLeft,
  isContentLeftRightFixedSize,
  onFilterSet = null,
  onSortSet,
  paddingX = 2,
  paddingTop,
  placeholderText = 'Search saved places',
  stateKey,
  textInputStateKey,
  top,
}) => {
  const dispatch = useDispatch();
  const clusterIds = useSelector(s => s.pins[stateKey].ids);
  const filter = useSelector(s => s.pins[stateKey].filter);
  const defaultSort = useSelector(s => s.pins[stateKey].defaultSort);
  const filterOptions = useSelector(s => s.pins[stateKey].filterOptions);
  const sort = useSelector(s => s.pins[stateKey].sort);
  const sortOptions = useSelector(s => s.pins[stateKey].sortOptions);
  const isPlaceIdsSearch = useSelector(s => s.pins.pinsListSearch.ids);

  const handleFilterClick = (filterClicked) => () => {
    dispatch(onFilterSet(filterClicked));
  };

  const handleClusterClearClick = () => () => {
    dispatch(pinsSearchIdsSet(null));
  };

  const handleSortClick = (sortClicked) => () => {
    dispatch(onSortSet(sortClicked));
  };

  useEffect(() => {
    dispatch(textInputPlaceholderSet({key: textInputStateKey, val: placeholderText}));
  }, []);

  return (
    <InputBar
      isBgTransparent
      isContentLeftRightFixedSize={isContentLeftRightFixedSize}
      paddingX={paddingX}
      paddingTop={paddingTop}
      stateKey={textInputStateKey}
      top={top}
      contentLeft={contentLeft}
      contentRight={
        <Flex alignItems="center" justifyContent="flex-end" gap={2} w="33%">
          {filter && !isPlaceIdsSearch && (
            <ButtonMinor
              alignItems="center"
              bg="wooorldBlue._"
              fontSize="1.5em"
              onClick={handleFilterClick(null)}
              position="relative"
            >
              {filterOptions.find(p => p.value === filter).emoji}
              <SmallCloseIcon
                background="red"
                borderRadius="full"
                color="white"
                pointerEvents="none"
                position="absolute"
                bottom="-.25em"
                right="-.25em"
                fontSize=".75em"
              />
            </ButtonMinor>
          )}

          {clusterIds && ( // TODO: this could be a 3D place, making this icon a bit confusing
            <ButtonMinor
              alignItems="center"
              bg="wooorldBlue._"
              fontSize="1.5em"
              onClick={handleClusterClearClick()}
              position="relative"
            >
              <Box position="absolute" fontSize=".5em" top="2.1em">
                <PanoClusterIcon
                  count={clusterIds.length}
                  size="5em"
                />
              </Box>

              <SmallCloseIcon
                background="red"
                borderRadius="full"
                color="white"
                pointerEvents="none"
                position="absolute"
                bottom="-.25em"
                right="-.25em"
                fontSize=".75em"
              />
            </ButtonMinor>
          )}


          <Filters
            isActive={filter || sort !== defaultSort}
            isSortOnly={!onFilterSet}
          >
            {/* Popover Content */}

            {onFilterSet && (<>
              <Text color="lightgrey">Filter</Text>
              {filterOptions.map(({value, label}, idx) => {
                const isSelected = filter === value;
                return (
                  <ButtonMinor
                    bg={isSelected ? 'wooorldBlue._' : null}
                    color={isSelected ? 'white' : null}
                    key={idx}
                    justifyContent="left"
                    onClick={handleFilterClick(value)}
                    position="relative"
                    size="sm"
                  >
                    {label}
                  </ButtonMinor>
                );
              })}

              <StackDivider border="solid 1px grey"/>
            </>)}

            <Text color="lightgrey">Sort by</Text>
            {sortOptions.map(({value, label, isSeparator}, idx) => {
              const isSelected = sort === value;
              return (
                <ButtonMinor
                  bg={isSelected ? 'wooorldBlue._' : null}
                  color={isSelected ? 'white!important' : null}
                  key={idx}
                  justifyContent="left"
                  onClick={handleSortClick(value)}
                  position="relative"
                  size="sm"
                >
                  {label}
                </ButtonMinor>
              );
            })}
          </Filters>
        </Flex>
      }
    >
      {children}
    </InputBar>
  );
};

export default PinsListFilters;
